import { render, staticRenderFns } from "./CardShowDetails.vue?vue&type=template&id=60fbcb96&scoped=true"
import script from "./CardShowDetails.vue?vue&type=script&lang=js"
export * from "./CardShowDetails.vue?vue&type=script&lang=js"
import style0 from "./CardShowDetails.vue?vue&type=style&index=0&id=60fbcb96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fbcb96",
  null
  
)

export default component.exports